function nextDescendingFirstIncludingUnsorted(currentDirection) {
    switch (currentDirection) {
        case null:
            return "desc";
        case "desc":
            return "asc";
        case "asc":
            return null;
    }
}

function nextAscendingFirstIncludingUnsorted(currentDirection) {
    switch (currentDirection) {
        case null:
            return "asc";
        case "asc":
            return "desc";
        case "desc":
            return null;
    }
}

function nextIncludingUnsorted(currentDirection, descendingFirst) {
    if (descendingFirst) {
        return nextDescendingFirstIncludingUnsorted(currentDirection);
    }
    return nextAscendingFirstIncludingUnsorted(currentDirection);
}

function nextExcludingUnsorted(currentDirection, descendingFirst) {
    switch (currentDirection) {
        case null:
            return descendingFirst ? "desc" : "asc";
        case "desc":
            return "asc";
        default:
            return "desc";
    }
}

export class SortState {
    constructor(field, direction, includeUnsorted = true) {
        this.field = field;
        this.direction = direction;
        this.includeUnsorted = includeUnsorted;
    }

    requestSortBy(field, descendingFirst) {
        const next = this.includeUnsorted ? nextIncludingUnsorted : nextExcludingUnsorted;
        if (this.field === field) {
            return new SortState(field, next(this.direction, descendingFirst), this.includeUnsorted);
        } else {
            return new SortState(field, next(null, descendingFirst), this.includeUnsorted);
        }
    }
}